// O-5024: the event-template endpoints answer with more than one error shape —
// `{ errors: [...] }` from the budget actions, and ActiveModel's `{ base: [...] }`
// (or `{ field: [...] }`) from the event-template ones. Reading only one of them
// is how a permanent refusal ("this show has recorded deposits") reached the
// booker as "Please try again", which is both wrong and un-actionable.
export default function templateErrorMessage(error, fallback) {
  const data = error?.response?.data;
  if (!data) return fallback;

  if (Array.isArray(data.errors) && data.errors.length) return data.errors.join(', ');
  if (Array.isArray(data)) return data.join(', ');

  if (typeof data === 'object') {
    const messages = Object.values(data)
      .filter(Array.isArray)
      .flat()
      .filter(Boolean);
    if (messages.length) return messages.join(', ');
  }

  return fallback;
}
